module.exports = __webpack_public_path__ + "img/spending-time-on-the-beach.d22203cc.svg";